module.exports = __webpack_public_path__ + "static/media/project17.f6315921.jpg";